export const doHeightMatch = (elem) => {
    if(elem.hasAttribute('data-heightmatch')){
        let heightmatch_elem = elem.dataset.heightmatch;
        let items = document.getElementsByClassName(heightmatch_elem);
        if(items){
            //console.log( "Found " + items.length + " matches");
            let mx = 0;
            for(let item of items){ mx = Math.max(mx, item.clientHeight)}
            // console.log("maxheight is " + mx);
            for(let item of items){item.setAttribute('style', 'height:' + mx +'px')}
        }  
    }
}
